import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Dropdown, Menu, message, Modal } from 'antd';
import './style.css';

// Actions
import { save_leave, get_leave, delete_leave, get_leave_by_id, edit_leave } from './actions/leave.action';


// Childs
import NewLeave from './childs/new.leave';
import EditLeave from './childs/edit.leave';

const confirm = Modal.confirm;
class LeaveType extends Component {

    constructor( props ){
        super( props );

        this.state = {
            new_leave_modal: false,
            edit_leave_modal: false,
            data: [],
            edit_data: []
        }

        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleController = this.handleController.bind( this );
        this.handleNewLeave = this.handleNewLeave.bind( this );
        this.handleSubmitEdit = this.handleSubmitEdit.bind (this );

    }


    handleController( e ){
        let self = this;

        if( e.key === '1' ){
            
            this.props.get_leave_by_id( e.item.props.id );

        } else if( e.key === '2' ){
            
            confirm({
                title: 'Do you Want to delete this leave?',
                onOk() {
                    self.props.delete_leave( e.item.props.id );
                },
                onCancel() {
                    // Nothing
                },
            });

        }
    }

    handleNewLeave(){
        this.setState({ new_leave_modal: true, edit_leave_modal: false });
    }

    handleSubmit( data ){

        this.props.save_leave( data );

        this.setState({
            new_leave_modal: false
        });

    }

    handleSubmitEdit( data ){

        this.props.edit_leave( data );

        this.setState({
            edit_leave_modal: false
        });

    }

    componentWillMount(){
        this.props.get_leave();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.leave_type.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        // Start

        if( nextProps.leave_type.STATUS.CODE === "200" && 
            nextProps.leave_type.STATUS.MESSAGE === "Successfully Saved Leave" ) {
            
            message.success('Successfully Saved leave');
            
            this.props.get_leave();

            this.setState({
                new_leave_modal: false,
                edit_leave_modal: false,
            });

        } else if ( nextProps.leave_type.STATUS.CODE === "200" && 
            nextProps.leave_type.STATUS.MESSAGE === "Successfully Listed Leave" ) {
            
            this.setState({
                data: nextProps.leave_type.OUTPUT.DATA,
                new_leave_modal: false,
                edit_leave_modal: false,
            });

        } else if ( nextProps.leave_type.STATUS.CODE === "200" && 
            nextProps.leave_type.STATUS.MESSAGE === "Successfully Deleted Leave" ) {
            
            message.success('Successfully Deleted leave');
            
            this.props.get_leave();

            this.setState({
                new_leave_modal: false,
                edit_leave_modal: false,
            });

        } else if ( nextProps.leave_type.STATUS.CODE === "200" && 
            nextProps.leave_type.STATUS.MESSAGE === "Successfully Listed By ID" ) {

            this.setState({
                edit_data: nextProps.leave_type.OUTPUT.DATA,
                edit_leave_modal: true,
                new_leave_modal: false
            });

        } else if ( nextProps.leave_type.STATUS.CODE === "200" && 
            nextProps.leave_type.STATUS.MESSAGE === "Successfully Updated Leave" ) {

            message.success('Successfully Updated leave');
            this.props.get_leave();

            this.setState({
                new_leave_modal: false,
                edit_leave_modal: false,
            });

        } else if ( nextProps.leave_type.STATUS.CODE === "400" ) {

            message.error( nextProps.leave_type.STATUS.MESSAGE );
            this.setState({
                new_leave_modal: false,
                edit_leave_modal: false,
            });

        }

        // End

    }

    render() {

        const leave_list = this.state.data.map( (item, i) => <li key={ i } className="list">
            <Dropdown overlay={ <Menu onClick={ this.handleController }>
                <Menu.Item key="1" id={ item.leave_type_id } ><Icon type="edit" />Edit &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                <Menu.Item key="2" id={ item.leave_type_id } ><Icon type="delete" />Delete &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                </Menu> } trigger={['click']}>
                <span className="control"><Icon type="ellipsis" /></span>
            </Dropdown>

            <h3>{ item.leave_type_name }</h3>
            <p style={{ textTransform: 'capitalize' }} >{ item.leave_type_type }</p>
        </li> );

        return (
            <div className="leave_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="form" />
                            &nbsp; Leave Types
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ this.handleNewLeave }
                            className="fl_right" type="primary" icon="plus">Add Leave Type</Button>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <ul className="leave_list">
                            { leave_list }
                        </ul>
                    </Col>
                </Row>

                <NewLeave onSubmit={ this.handleSubmit } onModel={ this.state.new_leave_modal } />
                <EditLeave onSubmit={ this.handleSubmitEdit } onModel={ this.state.edit_leave_modal } data={ this.state.edit_data } />

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        leave_type: state.leave_type
    }
}

export default connect( mapStatetoProps, { save_leave, get_leave, delete_leave, get_leave_by_id, edit_leave })( LeaveType );


// WEBPACK FOOTER //
// ./src/pages/leave_type/index.js